import { useContext } from "react";

import { BillingPlanSubscriptionContext } from "@app/common/providers/BillingPlanSubscriptionContext";

/**
 * Exposes a lightweight context of a user's `currentPlan` and `subscription`
 */
const useBillingPlanSubscriptionContext = () => {
  return useContext(BillingPlanSubscriptionContext);
};

export default useBillingPlanSubscriptionContext;
